// Constantes RBAC côté frontend (navigation & libellés)
export const ROLE_LABELS = {
  admin_technique: "Administrateur technique",
  responsable_qualite: "Responsable qualité",
  directeur_medical: "Directeur médical",
  chef_service: "Chef de service",
  pathologiste: "Pathologiste",
  pathologiste_distant: "Pathologiste distant",
  expert_externe: "Pathologiste Expert",
  technicien: "Technicien de laboratoire",
  secretaire: "Secrétaire médicale",
  clinicien: "Médecin clinicien",
};

export const NO_CLINICAL = ["admin_technique"];
export const ADMIN_ROLES = ["admin_technique", "chef_service"];
export const AUDIT_ROLES = ["admin_technique", "responsable_qualite", "directeur_medical", "chef_service"];
export const CREATE_CLINICAL = ["secretaire", "technicien", "chef_service", "pathologiste", "pathologiste_distant"];
export const REPORT_WRITE = ["pathologiste", "pathologiste_distant", "chef_service", "expert_externe"];

export const PRIORITE_LABELS = { normal: "Normal", urgent: "Urgent (24h)", stat: "STAT / Extemporané" };
export const STATUT_ORDER = ["recue", "macroscopie", "inclusion", "coupe", "coloration", "ihc", "moleculaire", "lecture", "redige", "valide", "transmis", "archive"];
export const STATUT_OPTIONNELS = ["ihc", "moleculaire"];
export const STATUT_LABELS = {
  recue: "Reçue", macroscopie: "Macroscopie", inclusion: "Inclusion paraffine",
  coupe: "Coupe (microtome)", coloration: "Coloration H&E", ihc: "Immunohistochimie",
  moleculaire: "Tests moléculaires", lecture: "Lecture pathologiste", redige: "Rapport rédigé",
  valide: "Validé / Signé", transmis: "Transmis", archive: "Archivé",
  en_preparation: "Macroscopie", histologie: "Coloration H&E", analyse: "Lecture pathologiste",
};
export const NATURE_LABELS = { biopsie: "Biopsie", piece_chirurgicale: "Pièce chirurgicale" };
export const DELAI_LABELS = { a_temps: "À temps", bientot: "Bientôt échu", retard: "En retard", termine: "Terminé" };

// Contrôle d'accès aux routes (miroir de la navigation)
export function canAccessPath(role, pathname) {
  if (!role) return false;
  if (pathname === "/" || pathname.startsWith("/conformite")) return true;
  if (pathname.startsWith("/notifications") || pathname.startsWith("/profile")) return true;
  if (pathname.startsWith("/patients"))
    return !["admin_technique", "clinicien", "expert_externe"].includes(role);
  if (pathname.startsWith("/demandes")) return role !== "admin_technique";
  if (pathname.startsWith("/parties")) return role !== "admin_technique";
  if (pathname.startsWith("/intervenants")) return true;
  if (pathname.startsWith("/wsi")) return role !== "admin_technique";
  if (pathname.startsWith("/analyses"))
    return !["admin_technique", "secretaire", "clinicien"].includes(role);
  if (pathname.startsWith("/admin"))
    return ["admin_technique", "chef_service", "responsable_qualite", "directeur_medical"].includes(role);
  return true;
}
